import {InputTextCustom, InputPasswordCustom, Loading} from "../../components";
import {useContext, useEffect, useState} from "react";
import {UserApi} from "../../apis";
import {LoadingContext, ToastContext, UserContext} from "../../contexts";
import Logo from "../../assets/img/logo-h.png";
import {useNavigate} from "react-router";

export const Login = () => {
  const navigate = useNavigate();
  const {setLoading} = useContext(LoadingContext);
  const {user, setUser} = useContext(UserContext);

  const [username, setUsername] = useState('');
  const [errorUsername, setErrorUsername] = useState(false);
  const [helperUsername, setHelperUsername] = useState('');

  const [password, setPassword] = useState('');
  const [errorPassword, setErrorPassword] = useState(false);
  const [helperPassword, setHelperPassword] = useState('');

  const toasts = useContext(ToastContext);
  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }

  const isLogado = () => (!!user.uuid);

  const decode = async () => {
    setLoading(true);
    let token = localStorage.getItem('token');
    if (token) {
      try {
        let respostaDecode = await UserApi.decode(token);
        if (!respostaDecode.error) {
          await setUser(
            {
              uuid: respostaDecode.data.uuid,
              nome: respostaDecode.data.nome,
              avatar: respostaDecode.data.avatar,
              nivel: respostaDecode.data.nivel,
              funcao: respostaDecode.data.funcao
            }
          );
          setLoading(false);
          navigate('/portalcolaborador/inicio');
        } else {
          setLoading(false);
          AddToast({texto:respostaDecode.error, tipo: "erro"});
        }
      } catch (e) {
        setLoading(false);
        localStorage.clear();
        AddToast({texto:e, tipo: "erro"});
      }
    }
    setLoading(false);
  }

  useEffect(() => {
    if (!isLogado()) {
      decode();
    }
  }, [])

  const login = async () => {
    setLoading(true);
    setErrorUsername(false);
    setErrorPassword(false);

    if (username.length === 0 || password.length === 0) {
      if (username.length === 0) {
        setHelperUsername("Campo não pode estar vazio");
        setErrorUsername(true);
      }
      if (password.length === 0) {
        setHelperPassword("Campo não pode estar vazio");
        setErrorPassword(true);
      }
    } else {
      try {
        let respostaLogin = await UserApi.login(username, password);
        if (!respostaLogin.error) {
          localStorage.setItem('token', respostaLogin.data.token);
          decode();
        } else {
          AddToast({texto:respostaLogin.error, tipo: "erro"});
          setLoading(false);
        }
      } catch (e) {
        AddToast({texto:e, tipo: "erro"});
        setLoading(false);
      }
    }
    setLoading(false);
  }

  return (
    <div className="login">
      <div className="form">
        <img className="logo" src={Logo} alt="Logo Nunes Peixoto"/>
        <InputTextCustom
          label="Nome de usuário"
          value={username}
          onChange={t => setUsername(t.target.value)}
          error={errorUsername}
          helperText={helperUsername}
        />
        <InputPasswordCustom
          label="Senha"
          value={password}
          onChange={t => setPassword(t.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') login()
          }}
          error={errorPassword}
          helperText={helperPassword}
        />
        <div className="btn btn-enviar" onClick={login}>
          Entrar
        </div>
      </div>
    </div>
  )
}